export function error<T>(message: string): Promise<T> {
    return Promise.reject<T>(new Error(message));
}

